import type { ListFilters } from '@arcual/lib-app-platform';
import type { Activation } from '../Activation.type';

// todo: migrate to @arcual/lib-app-platform
export enum ArcualViewingRoomStatus {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export interface ViewingRoomFilters extends ListFilters {
  searchOnValue?: string | null;
  filterByStatus?: Array<ArcualViewingRoomStatus>;
  filterByContactSegments?: string;
  filterByOwnerId?: string | null;
  sortOn?: string;
  sortDirection?: 'asc' | 'desc';
}

export type ViewingRoomsPayload = {
  name: Activation['name'];
  subdomain: Activation['subdomain'];
  activationTypeEnum?: Activation['activationTypeEnum'];
  isApiOnly?: Activation['isApiOnly'];
  activationCurrency?: Activation['activationCurrency'];
};
